import axios from "axios";

export const setAxiosHeaderToken = () => {
	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			const originalRequest = { ...error.config };
			if (error.response.status === 401 && !originalRequest._retry) {
				originalRequest._retry = true;
				const refreshToken =
					"eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjY4NTcxNDEsIm9yZ0lkIjoxNzAsInR5cGUiOjMsIm1vYmlsZSI6IjkxNzk3NjY2MjM1OCIsIm5hbWUiOiJBYmhpc2hlayIsImVtYWlsIjoiYWJoaXNoZWszQGNsYXNzcGx1cy5jbyIsImlzSW50ZXJuYXRpb25hbCI6MCwiZGVmYXVsdExhbmd1YWdlIjoiRU4iLCJjb3VudHJ5Q29kZSI6IklOIiwiY291bnRyeUlTTyI6IjkxIiwidGltZXpvbmUiOiJHTVQrNTozMCIsImlhdCI6MTY0NjExNTA2NX0.Fpe6L03GXHqJMXWfJ0TZwPk4iJmqZYcCrXsOsHTiNnkU51Ov01Tiw9VYTtG4GtLMKoqyzbQGe2B8OFYnF3qdAw";
				return axios
					.post(
						"https://api.classplusapp.com/users/refreshAccessToken",
						{ refreshToken: refreshToken },
						{ headers: { "Api-Version": 8 } }
					)
					.then((res) => {
						if (res.status === 200) {
							axios.defaults.headers.common["x-access-token"] =
								res.data.data.token;
							originalRequest.headers["x-access-token"] = res.data.data.token;
							return axios(originalRequest);
						}
					});
			}

			return Promise.reject(error);
		}
	);
};
